import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import logo from '../../assets/img/logo.png';

const HINT_KEYS = ['LoadingHint0', 'LoadingHint1', 'LoadingHint2', 'LoadingHint3', 'LoadingHint4'];
const HINT_INTERVAL_MS = 2500;

export function ViewerLoadingScreen({ visible }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(true);
  const [hintIndex, setHintIndex] = useState(0);

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(() => setShow(false), 450);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  useEffect(() => {
    if (!visible) return;
    const interval = setInterval(() => {
      setHintIndex((i) => Math.min(i + 1, HINT_KEYS.length - 1));
    }, HINT_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [visible]);

  if (!show) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        bgcolor: '#212529',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.4s ease',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <Box
        component='img'
        src={logo}
        alt='Mirukuru logo'
        sx={{ width: 300, mb: 3 }}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 4 }}>
        <CircularProgress size={24} thickness={4} />
        <Typography variant='caption' sx={{ color: 'grey.400' }}>
          {t(HINT_KEYS[hintIndex])}
        </Typography>
      </Box>
    </Box>
  );
}
